<phar-confirm key="warning" />
<phar-confirm key="confirmation" />
<p-toast position="top-right" />
<router-outlet />